// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';
import {
  IntegrationSummary,
  type IntegrationSummaryWireFormat,
  NewIntegrationSummary,
} from '../IntegrationSummary/IntegrationSummary';

export class QuoteExportBlocker {
  readonly integration: IntegrationSummary;
  readonly reason: Enums.QuoteExportReason;
  readonly productIds: string[];

  constructor(data: { [key: string]: any } = {}) {
    this.integration = NewIntegrationSummary(data.integration);
    this.reason = data.reason === undefined ? Enums.QuoteExportReason.Unknown : data.reason;
    this.productIds = (data.productIds ?? []).map((productIds: any) =>
      productIds === undefined ? NIL_UUID : productIds,
    );
  }

  static zero(): QuoteExportBlocker {
    const zeroValues: ExcludeMethodsDeep<QuoteExportBlocker> = {
      integration: IntegrationSummary.zero(),
      reason: Enums.QuoteExportReason.Unknown,
      productIds: [],
    };
    return new QuoteExportBlocker(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteExportBlockerWireFormat = {
  integration: IntegrationSummaryWireFormat;
  reason: string;
  productIds: string[];
};

type NewQuoteExportBlockerProps = PartialDeep<QuoteExportBlocker, { recurseIntoArrays: true }>;
export const NewQuoteExportBlocker: (props: NewQuoteExportBlockerProps) => QuoteExportBlocker = (
  props,
) => new QuoteExportBlocker(props);

type NewQuoteExportBlockerFromWireFormatProps = PartialDeep<
  QuoteExportBlockerWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteExportBlockerFromWireFormat: (
  props: NewQuoteExportBlockerFromWireFormatProps,
) => QuoteExportBlocker = (props) => new QuoteExportBlocker(props);
